import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const SelectShortListModalWrapper = styled.div.attrs({
    className: "select-short-list-modal",
  })<{scroll?: boolean}>`
    user-select: none;
    height: 100vh;
    width: 100%;
    overflow-y: ${p => p.scroll ? 'scroll' : 'hidden'};
  
    &::-webkit-scrollbar {
      height: 1px;
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
    }
  
    
  
    *::-webkit-scrollbar {
      width: 6px; /* ширина scrollbar */
      height: 10px;
    }
    *::-webkit-scrollbar-track {
      background: transparent; /* цвет дорожки */
    }
    *::-webkit-scrollbar-thumb {
      border-radius: 3px; /* закругления плашки */
      background: rgba(0, 0, 0, 0.596);
    }

    button[type=submit] {
      color: #151514 !important;
    }
  `;

  export const SelectShortListModalContainer = styled(FlexBox).attrs({
    className: "--container",
  })`
    flex-direction: column;
    overflow-y: auto;
    width: 1152px;
    margin: 102px auto 0;
  
    @media (max-width: ${LayoutConst.screen.l_12}px) {
      width: 940px;
    }
  
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100%;
      margin-top: 6px;
      padding: 0 10px;
    }
  `;

  export const ContentWrapper = styled.div`
    .grid-w {
      z-index: 0;
      padding-top: 0;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      .grid-w {
        padding-bottom: 24px;
      }
    }
  `;import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const SelectShortListModalWrapper = styled.div.attrs({
    className: "select-short-list-modal",
  })<{scroll?: boolean}>`
    user-select: none;
    height: 100vh;
    width: 100%;
    overflow-y: ${p => p.scroll ? 'scroll' : 'hidden'};
  
    &::-webkit-scrollbar {
      height: 1px;
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
    }
  
    
  
    *::-webkit-scrollbar {
      width: 6px; /* ширина scrollbar */
      height: 10px;
    }
    *::-webkit-scrollbar-track {
      background: transparent; /* цвет дорожки */
    }
    *::-webkit-scrollbar-thumb {
      border-radius: 3px; /* закругления плашки */
      background: rgba(0, 0, 0, 0.596);
    }

    button[type=submit] {
      color: #151514 !important;
    }
  `;

  export const SelectShortListModalContainer = styled(FlexBox).attrs({
    className: "--container",
  })`
    flex-direction: column;
    overflow-y: auto;
    width: 1152px;
    margin: 102px auto 0;
  
    @media (max-width: ${LayoutConst.screen.l_12}px) {
      width: 940px;
    }
  
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100%;
      margin-top: 6px;
      padding: 0 10px;
    }
  `;

  export const ContentWrapper = styled.div`
    .grid-w {
      z-index: 0;
      padding-top: 0;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      .grid-w {
        padding-bottom: 24px;
      }
    }
  `;